import { useDispatch } from "react-redux";
import { Column } from "../../../../core/components/Column";
import { CustomButton } from "../../../../core/components/CustomButton";
import { TextComponent } from "../../../../core/components/TextComponent";
import { AppDispatch } from "../../../../core/store/store";
import { clearChat } from "../store/ChatThunk";
import { useState } from "react";
import { deleteHistory, deleteMessageText, updatedChatStatusReceived, deleteChat, deleteSelectedChat } from "../store/ChatSlice";
import { onDeleteBlockMatch, onDeleteTrashUser } from "../../../match/presentation/store/MatchThunk";

export const ChatBloqued = ({ id, name, status, variant, status_user, user_id, isHistory }: { id: string; name: string; status: string; variant?: string; status_user: string; user_id: string, isHistory: boolean }) => {
	const dispatch: AppDispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const [loadingDelete, setLoadingDelete] = useState(false);
	const handleClearChat = async () => {
		setLoading(true);
		await dispatch(clearChat(id));
		dispatch(deleteMessageText({chat_id: id}));
		dispatch(deleteHistory());
		setLoading(false);
	};

	const handleReactiveChat = async () => {
		setLoadingDelete(true);
		await dispatch(onDeleteBlockMatch({
			match_id: id,
			block: false,
		}))
		setLoadingDelete(false);
		dispatch(
			updatedChatStatusReceived({
				id: id,
				status_user_id1: variant === "text" ? "active" : status_user,
				status_user_id2: variant !== "text" ? "active" : status_user,
			})
		);
	};

	const handleDeleteMatch = async () => {
		if (!user_id) return;
		setLoadingDelete(true);
		await dispatch(onDeleteTrashUser(user_id));
		dispatch(deleteChat({ chat_id: id }));
		dispatch(deleteSelectedChat());
		setLoadingDelete(false);
	};

	return (
		<Column className="relative min-w-20 max-w-[27rem] shadow-lg p-4 md:p-5 rounded-2xl self-start bg-white rounded-bl-none text-black">
			<TextComponent
				variant="h6"
				className="max-w-[22.5rem] break-words whitespace-pre-wrap"
			>
				<Column className="gap-2">
					<TextComponent
						variant="nh6"
						className="font-semibold"
					>
						{variant === "text" ? (
							<>
								{status === "blocked" ? "You blocked" : "You left the conversation with"} <span className="text-primary font-bold">{name}</span>
							</>
						) : (
							<>
								<span className="text-primary font-bold">{name}</span> {status === "blocked" ? "has blocked you" : status === "leaved" ? `has left the conversation` : status === "deleted" ? "has deleted the match" : "no longer exists"}
							</>
						)}
					</TextComponent>
					{isHistory && 
						<CustomButton
							onClick={handleClearChat}
							loading={loading}
						>
							Clear chat history
						</CustomButton>
					}
					{status === "leaved" && variant === "text" && <CustomButton onClick={handleReactiveChat} loading={loadingDelete}>Reactivate chat</CustomButton>}
					{status !== "leaved" && (
						<CustomButton
							onClick={handleDeleteMatch}
							loading={loadingDelete}
						>
							Delete Match
						</CustomButton>
					)}
				</Column>
			</TextComponent>
		</Column>
	);
};
